/** Thème partagé — Synthèse, Leaders, Flux de marché */
export const THEME_KEY = "invelpsTheme";
export const THEME_EVENT = "invelps-theme-change";

/** Vert header INVELPS — identique sur toute l’app */
export const INVELPS_NAV0 = "#2e574f";
export const INVELPS_NAV1 = "#3d7068";
export const INVELPS_NAV_GRADIENT = `linear-gradient(150deg, ${INVELPS_NAV0} 0%, ${INVELPS_NAV1} 100%)`;

export const MARKET_LIGHT = {
  bg: "#fbfaf7",
  appBg: "#fbfaf7",
  paper: "#fff",
  paperAlt: "#f7f5f0",
  ink: "#1f2a24",
  ink2: "#243028",
  muted: "#6f7b74",
  line: "rgba(30,40,34,.10)",
  line2: "rgba(30,40,34,.06)",
  shadow: "0 10px 30px rgba(16,24,20,.10)",
  shadow2: "0 6px 16px rgba(16,24,20,.08)",
  rowH: "rgba(181,154,91,.08)",
};

export const MARKET_DARK = {
  bg: "#0b1220",
  appBg: "#0b1220",
  paper: "rgba(15,23,42,.92)",
  paperAlt: "rgba(15,23,42,.55)",
  ink: "#e2e8f0",
  ink2: "#cbd5e1",
  muted: "#94a3b8",
  line: "rgba(148,163,184,.18)",
  line2: "rgba(148,163,184,.09)",
  shadow: "0 10px 30px rgba(0,0,0,.35)",
  shadow2: "0 6px 16px rgba(0,0,0,.25)",
  rowH: "rgba(181,154,91,.09)",
};

export function readMarketDarkMode() {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(THEME_KEY) === "dark";
}

export const GLOBAL_THEME_OVERRIDES_CSS = `
html[data-theme="dark"] .inv-nav-search-dropdown{
  background:rgba(15,23,42,.98);
  border-color:rgba(148,163,184,.2);
  box-shadow:0 8px 24px rgba(0,0,0,.45);
}
html[data-theme="dark"] .inv-nav-search-hit{
  border-bottom-color:rgba(148,163,184,.12);
}
html[data-theme="dark"] .inv-nav-search-hit:hover{background:rgba(181,154,91,.12);}
html[data-theme="dark"] .inv-nav-search-sym{color:var(--ink);}
html[data-theme="dark"] .inv-nav-search-name{color:var(--muted);}
html[data-theme="dark"] .inv-nav-search-hit.muted{color:var(--muted);}
html[data-theme="dark"] .mps-subnav-page .mps-link{color:var(--muted);}
html[data-theme="dark"] .mps-subnav-page .mps-link:hover,
html[data-theme="dark"] .mps-subnav-page .mps-link.active{color:var(--ink);}
`;

export function injectGlobalThemeStyles() {
  if (typeof document === "undefined") return;
  if (document.getElementById("inv-global-theme-css")) return;
  const el = document.createElement("style");
  el.id = "inv-global-theme-css";
  el.textContent = GLOBAL_THEME_OVERRIDES_CSS;
  document.head.appendChild(el);
}

export function syncMarketTheme(isDark) {
  if (typeof document === "undefined") return;
  injectGlobalThemeStyles();
  const th = isDark ? MARKET_DARK : MARKET_LIGHT;
  const r = document.documentElement;
  r.style.colorScheme = isDark ? "dark" : "light";
  [
    ["--bg", th.bg],
    ["--app-bg", th.appBg],
    ["--paper", th.paper],
    ["--paper-alt", th.paperAlt],
    ["--ink", th.ink],
    ["--ink2", th.ink2],
    ["--muted", th.muted],
    ["--line", th.line],
    ["--line2", th.line2],
    ["--shadow", th.shadow],
    ["--shadow2", th.shadow2],
    ["--row-h", th.rowH],
  ].forEach(([k, v]) => r.style.setProperty(k, v));
  r.setAttribute("data-theme", isDark ? "dark" : "light");
  document.body.style.background = isDark
    ? th.appBg
    : `radial-gradient(1200px 400px at 50% 0%, rgba(181,154,91,.12), transparent 55%), linear-gradient(${th.bg}, ${th.bg})`;
  document.body.style.color = th.ink;
}

export function dispatchThemeChange(isDark) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: { isDark } }));
}
